import { useRef, useState } from "react";
import { Upload, Loader2, ImageIcon } from "lucide-react";
import { toast } from "sonner";
import { uploadImage, imgUrl } from "@/lib/api";

/**
 * Image upload button. Uploads the selected file to object storage and
 * returns the stored URL via onUploaded(url).
 */
export function ImageUpload({ value, onUploaded, label = "Nahrať fotku", testid = "image-upload", className = "" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const pick = () => ref.current?.click();

  const onChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) return toast.error("Vyberte obrázok.");
    if (file.size > 8 * 1024 * 1024) return toast.error("Obrázok je príliš veľký (max 8 MB).");
    setBusy(true);
    try {
      const url = await uploadImage(file);
      onUploaded(url);
      toast.success("Fotka nahraná");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Nahrávanie zlyhalo");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <input ref={ref} type="file" accept="image/*" onChange={onChange} className="hidden" data-testid={`${testid}-input`} />
      <div className="w-14 h-14 shrink-0 bg-ink border border-white/15 flex items-center justify-center overflow-hidden">
        {value ? <img src={imgUrl(value)} alt="" className="w-full h-full object-cover" /> : <ImageIcon className="w-5 h-5 text-white/30" />}
      </div>
      <button
        type="button"
        onClick={pick}
        disabled={busy}
        data-testid={`${testid}-btn`}
        className="flex items-center gap-2 border border-white/20 hover:border-gold text-white/80 hover:text-gold px-4 py-2 text-sm transition-colors disabled:opacity-50"
      >
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} {label}
      </button>
    </div>
  );
}

export default ImageUpload;
